import React from "react";
import Spinner from "../../../../components/presentationals/Spinner";
import Error from "../../../../components/Error/index";
import ActivationSalesCustomizedTables from "../../../../components/table/activationSalesCustomizedTables";

const Top5RetailersView = ({ top5RetailersObj }) => {
  let { top5RetailersData } = top5RetailersObj;

  return (
    <>
      {top5RetailersObj.loading ? (
        <Spinner />
      ) : Object.keys(top5RetailersData).length ? (
        <ActivationSalesCustomizedTables data={top5RetailersData} />
      ) : (
        <Error error={top5RetailersObj.error} />
      )}
    </>
  );
};

export default Top5RetailersView;
